import React from 'react'
import { Box, TextField } from '@mui/material'
import moment from 'moment'
import TimeSelect from './TimeSelect'

const FORMAT = 'YYYY-MM-DDTHH:mm'
const DATE = 'YYYY-MM-DD'

/**
 * One moment in time as a date field plus a five-minute time list, matching how the
 * activity's own start and end are picked. Used for the enrolment window, where a
 * datetime-local input made the user fight a combined widget for a value they think
 * of as "this day, at this time".
 */
function DateTimeSelect({ label, value, onChange, defaultTime, dateWidth, timeWidth }) {
  const parsed = value ? moment(value, FORMAT) : null
  const valid = !!(parsed && parsed.isValid())
  const date = valid ? parsed.format(DATE) : ''
  const time = valid ? parsed.format('HH:mm') : ''

  const emit = (nextDate, nextTime) => {
    if (!nextDate) {
      onChange('')
      return
    }
    onChange(moment(nextDate + 'T' + (nextTime || defaultTime || '12:00'), FORMAT).format(FORMAT))
  }

  return (
    <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'flex-start' }}>
      <TextField
        required
        label={label}
        type='date'
        size='small'
        sx={{ flex: dateWidth || '0 1 190px' }}
        value={date}
        onChange={(e) => emit(e.target.value, time)}
        InputLabelProps={{ shrink: true }}
      />
      <TimeSelect
        label='Klo'
        value={time}
        onChange={(next) => emit(date || moment().format(DATE), next)}
        sx={timeWidth || { flex: '0 0 130px' }}
      />
    </Box>
  )
}

export default DateTimeSelect
